// extracted by css-extract-rspack-plugin
export default {"section":"section-gRcxr7","iconFrame":"iconFrame-C9dlor"};